/**
 * Seed data for the My Writing feature — gives first-time visitors something
 * to see rather than a blank dashboard.
 */

const now = Date.now();
const HOUR = 60 * 60 * 1000;
const DAY = 24 * HOUR;

const chapterContent = (paragraphs) =>
  paragraphs.map((p) => `<p>${p}</p>`).join('');

export const SEED_STORIES = [
  {
    id: 'story_seed_1',
    title: 'The Things We Never Said',
    description: 'A story about two people who kept missing each other, told in the letters they never sent.',
    genre: 'Contemporary',
    tags: ['slow-burn', 'letters', 'second-chances'],
    cover: { type: 'typographic' },
    status: 'draft',
    visibility: 'private',
    goal: 50000,
    isFavorite: true,
    createdAt: now - 40 * DAY,
    updatedAt: now - 18 * 60 * 1000,
    chapters: [
      {
        id: 'ch_seed_1_1',
        title: 'The First Time',
        content: chapterContent([
          'The rain had a way of making the city feel smaller, like it was folding in on itself one street at a time.',
          'She stood under the awning of the corner bookshop, watching the water pool at the edge of the curb, and did not notice him until he was already beside her.',
        ]),
        createdAt: now - 40 * DAY,
        updatedAt: now - 30 * DAY,
      },
      {
        id: 'ch_seed_1_2',
        title: 'Almost',
        content: chapterContent([
          'There is a particular kind of ache that comes from almost — almost saying it, almost staying, almost being brave enough.',
          'He would think about that afternoon for years, replaying it the way you replay a song you are not ready to let go of.',
        ]),
        createdAt: now - 35 * DAY,
        updatedAt: now - 10 * DAY,
      },
      {
        id: 'ch_seed_1_3',
        title: 'Things Left Unsaid',
        content: chapterContent([
          'The letter sat in the drawer for three years before she finally worked up the nerve to send it — and by then, everything had changed.',
        ]),
        createdAt: now - 20 * DAY,
        updatedAt: now - 18 * 60 * 1000,
      },
    ],
  },
  {
    id: 'story_seed_2',
    title: 'Lanterns Over Kestrel Bay',
    description: 'A coastal fantasy about a lighthouse keeper who discovers her lamp is the only thing holding back the tide of an older world.',
    genre: 'Fantasy',
    tags: ['found-family', 'sea-magic'],
    cover: { type: 'typographic' },
    status: 'draft',
    visibility: 'private',
    goal: 80000,
    isFavorite: false,
    createdAt: now - 12 * DAY,
    updatedAt: now - 3 * DAY,
    chapters: [
      {
        id: 'ch_seed_2_1',
        title: 'The Keeper',
        content: chapterContent([
          'Mira had kept the lantern lit for six years without missing a single night, though no ship had passed Kestrel Bay in almost as long.',
        ]),
        createdAt: now - 12 * DAY,
        updatedAt: now - 3 * DAY,
      },
    ],
  },
  {
    id: 'story_seed_3',
    title: 'Salt & Static',
    description: 'A finished novella about a radio operator on an abandoned research station who starts receiving messages from a station that was decommissioned decades ago.',
    genre: 'Science Fiction',
    tags: ['mystery', 'isolation'],
    cover: { type: 'typographic' },
    status: 'completed',
    visibility: 'unlisted',
    goal: 30000,
    isFavorite: false,
    createdAt: now - 120 * DAY,
    updatedAt: now - 25 * DAY,
    chapters: [
      {
        id: 'ch_seed_3_1',
        title: 'Signal',
        content: chapterContent([
          'The first message came through at 3:14 a.m., in a code the station had retired eleven years before Wren was born.',
        ]),
        createdAt: now - 120 * DAY,
        updatedAt: now - 100 * DAY,
      },
      {
        id: 'ch_seed_3_2',
        title: 'Static',
        content: chapterContent([
          'By the third night, Wren had stopped telling herself it was interference.',
        ]),
        createdAt: now - 90 * DAY,
        updatedAt: now - 25 * DAY,
      },
    ],
  },
];
